import { computed, Directive, input } from '@angular/core';
import { GRADIENTS } from '@shared/constants/gradients';
import { cn } from '@shared/helpers/cn';

export type SupportedGradient =
  | 'purple'
  | 'purple-light'
  | 'blue'
  | 'yellow'
  | 'orange'
  | 'orange-light'
  | 'purple-light-100'
  | 'blue-light'
  | 'amber-light'
  | 'red'
  | 'red-light'
  | 'blue-light-100'
  | 'green'
  | 'green-500'
  | 'green-light-100'
  | 'location'
  | 'bg'
  | 'bg-light';

@Directive({
  selector: '[appGradient]',
  standalone: true,
  host: { '[class]': 'styles()' },
})
export class AppGradientDirective {
  color = input<SupportedGradient>('purple');

  appGradient = input<boolean | ''>(true);
  class = input<string>();

  #base = 'shadow-sm';

  public styles = computed(() => {
    return cn(
      {
        [this.#base]: this.appGradient() !== false,
        // Purple
        [GRADIENTS.purple.base]:
          this.color() === 'purple' && this.appGradient() !== false,
        [GRADIENTS.purple.light]:
          this.color() === 'purple-light' && this.appGradient() !== false,
        [GRADIENTS.purple.light100]:
          this.color() === 'purple-light-100' && this.appGradient() !== false,

        // Orange
        [GRADIENTS.orange.light]:
          this.color() === 'orange-light' && this.appGradient() !== false,
        [GRADIENTS.orange.base]:
          this.color() === 'orange' && this.appGradient() !== false,

        // Amber
        [GRADIENTS.amber.light]:
          this.color() === 'amber-light' && this.appGradient() !== false,

        // Blue
        [GRADIENTS.blue.base]:
          this.color() === 'blue' && this.appGradient() !== false,
        [GRADIENTS.blue.light]:
          this.color() === 'blue-light' && this.appGradient() !== false,
        [GRADIENTS.blue.light100]:
          this.color() === 'blue-light-100' && this.appGradient() !== false,

        // Green
        [GRADIENTS.green.base]:
          this.color() === 'green' && this.appGradient() !== false,
        [GRADIENTS.green.base500]:
          this.color() === 'green-500' && this.appGradient() !== false,
        [GRADIENTS.green.light100]:
          this.color() === 'green-light-100' && this.appGradient() !== false,

        // Red
        [GRADIENTS.red.base]:
          this.color() === 'red' && this.appGradient() !== false,
        [GRADIENTS.red.light]:
          this.color() === 'red-light' && this.appGradient() !== false,

        // nav background
        [GRADIENTS.background.base]: this.color() === 'bg',
        [GRADIENTS.background.light]: this.color() === 'bg-light',
        '!bg-[var(--app-theme-hero-bg)] text-[var(--app-theme-primary-text)]':
          this.color() === 'location' && this.appGradient() !== false,
        // yellow
        [GRADIENTS.yellow.base]:
          this.color() === 'yellow' && this.appGradient() !== false,
      },
      this.class(),
    );
  });
}
